module.exports = __webpack_public_path__ + "static/media/appyhere-seeker-logo.678bb211.svg";